module.exports = __webpack_public_path__ + "static/img/bg1.740c460.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/app/bg1.png
// module id = C8wd
// module chunks = 69